import PublicLayout from "@/components/PublicLayout";
import { ShieldCheck, BadgeCheck, GraduationCap, Star, Siren, MapPin, Users, Phone, Lock } from "lucide-react";

const FRAMEWORK = [
  { icon: ShieldCheck, t: "Aadhaar e-KYC", d: "Identity verified in real time via UIDAI API. Not self-declared. Machine-confirmed before profile goes live." },
  { icon: BadgeCheck, t: "Police & Background Check", d: "Criminal background check via AuthBridge and BetterPlace before first booking. Re-screened annually." },
  { icon: GraduationCap, t: "Credential Verification", d: "Qualification certificates cross-checked against issuing institutions. Nursing registrations verified against INC and State Nursing Councils. RCI confirmed for speech/audiology/clinical psychology." },
  { icon: Star, t: "BookMyCarer Certified", d: "Platform competency test — practical + theoretical. Awarded after 10 verified engagements. A credential, not a warranty." },
];

export default function TrustSafety() {
  return (
    <PublicLayout>
      <section className="bg-ink text-ivory">
        <div className="bmc-wrap py-16">
          <div className="eyebrow text-butter">Trust & Safety</div>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-ivory mt-3">Verified isn't a badge. It's the whole platform.</h1>
          <p className="text-lg text-ivory/70 mt-4 max-w-2xl">Every carer passes the same multi-layer checks before they ever appear in search.</p>
        </div>
      </section>

      <section className="bmc-wrap py-16 space-y-4">
        {FRAMEWORK.map((f, i) => (
          <div key={f.t} className={`rounded-r-lg p-7 flex gap-5 ${i % 2 ? "bg-ivory-2" : "bg-card border border-line-2"}`}>
            <span className="grid place-items-center w-14 h-14 rounded-2xl bg-coral-soft text-coral shrink-0"><f.icon size={26} /></span>
            <div><h3 className="text-xl font-bold">{f.t}</h3><p className="text-ink-soft mt-2">{f.d}</p></div>
          </div>
        ))}
      </section>

      <section className="bmc-wrap pb-16">
        <div className="bg-coral-soft rounded-r-lg p-10 text-center">
          <h2 className="text-3xl font-bold text-coral-deep">The Trust Guarantee</h2>
          <p className="text-coral-deep/80 mt-3 max-w-2xl mx-auto">If your booked carer doesn't arrive, or care falls below the standard agreed at booking, we will replace your carer within 2 hours or refund your booking in full. Backed by our insurance partner — not just a promise.</p>
        </div>
      </section>

      <section className="bg-sage-soft py-16">
        <div className="bmc-wrap">
          <h2 className="text-3xl font-bold">Female Carer Safety Programme</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
            {[[Siren, "In-app SOS / panic button"], [MapPin, "GPS location shared with family during visits"], [Users, "Verified families only — family Aadhaar checked before carer address shared"], [Phone, "24/7 carer support helpline"]].map(([I, t]) => (
              <div key={t} className="card-bmc p-5"><I size={24} className="text-sage-deep" /><p className="font-semibold mt-3 text-sm">{t}</p></div>
            ))}
          </div>
        </div>
      </section>

      <section className="bmc-wrap py-16">
        <h2 className="text-3xl font-bold flex items-center gap-3"><Lock size={26} className="text-coral" /> Data & Privacy</h2>
        <ul className="grid sm:grid-cols-2 gap-4 mt-6">
          {["Aadhaar data not stored — verification is a real-time API call only.", "Payment data PCI-DSS compliant via Razorpay.", "ABHA health data encrypted end-to-end.", "Compliant with India's Digital Personal Data Protection Act (DPDP) 2023."].map((t) => (
            <li key={t} className="card-bmc p-5 text-sm text-ink-soft">{t}</li>
          ))}
        </ul>
      </section>
    </PublicLayout>
  );
}
